// extracted by mini-css-extract-plugin
export default {"list":"list___f5WaW","item":"item___ItlAR","label":"label___LROLZ","value":"value___qqSEk"};